import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RegistroProductorContexto {
	idEmpresa: number;
	razonSocialEmpresa: string;
	cuitEmpresa: string;
	mail: string;
	idUnidadProductiva?: number;
}

export interface RegistroProductorConfirmarRequest {
	token: string;
	nombre: string;
	apellido: string;
	cuil: string;
	dni: string;
	sexo: string;
	numeroTramiteDni: string;
	mailOverride?: string;
}

export interface RegistroProductorConfirmarResponse {
	success: boolean;
	redeemUrl: string;
	emailAlreadyExists?: boolean;
}

export interface RegistroProductorVincularRequest {
	token: string;
}

export interface RegistroProductorVincularResponse {
	success: boolean;
}

export interface RegistroProductorIdentidadStorage {
	nombre: string;
	apellido: string;
	cuil: string;
	dni: string;
	sexo: string;
	numeroTramiteDni: string;
}

@Injectable({
	providedIn: 'root'
})
export class RegistroProductorService {
	private readonly baseUrl = `${environment.apiUrl}/RegistroProductor`;

	constructor(private http: HttpClient) {}

	obtenerContexto(token: string): Observable<RegistroProductorContexto> {
		return this.http.get<RegistroProductorContexto>(
			`${this.baseUrl}/contexto`,
			{ params: { token } }
		);
	}

	confirmar(
		payload: RegistroProductorConfirmarRequest
	): Observable<RegistroProductorConfirmarResponse> {
		return this.http.post<RegistroProductorConfirmarResponse>(
			`${this.baseUrl}/confirmar`,
			payload
		);
	}

	vincular(
		payload: RegistroProductorVincularRequest
	): Observable<RegistroProductorVincularResponse> {
		return this.http.post<RegistroProductorVincularResponse>(
			`${this.baseUrl}/vincular`,
			payload
		);
	}
}
